<template>
  <div id="mapDiv" class="w-full h-96"></div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
import styles from "../../components/Map/gmap-style";

// Module-level loader configuration
const loaderOptions = {
  apiKey: "AIzaSyCiLDfWO0dPjiiJEUqYWoM_LjUAJQOgyGk",
  version: "weekly",
  libraries: ["visualization"],
};
const loader = new Loader(loaderOptions);
// my addition comment

export default {
  props: ["heatmapData"],

  async mounted() {
    if (window.google && window.google.maps && window.google.visualization) {
      this.initMap();
      return;
    }
    // Load Google Maps once with consistent options
    await loader.load();
    this.initMap();
  },

  methods: {
    calculateBounds() {
      const bounds = new google.maps.LatLngBounds();
      this.bounds = bounds;
    },
    getCenterCoordinates() {
      const countryCode = this.$store.state.auth.country_code;

      let center = { lat: 0, lng: 0 };

      if (countryCode === "EG") {
        center = { lat: 30.033333, lng: 31.233334 }; // cairo center
      } else if (countryCode === "SA") {
        center = { lat: 26.4207, lng: 50.0888 }; // Dammam center
      }

      return center;
    },
    initMap() {
      const EGYPT_SUPPORTED_CITIES_BOUNDS = {
        // cairo bounds
        north: 30.40506194749335,
        south: 29.79494721124095,
        west: 30.738370122571716,
        east: 31.892975122889684,
      };

      const SUDIA_ARABIA_SUPPORTED_CITIES_BOUNDS = {
        // Damman and Khobar bounds
        north: 26.45, // Slightly north of Dammam's latitude
        south: 26.2, // Slightly south of Khobar's latitude
        west: 49.95, // Slightly west of Dammam's longitude
        east: 50.25, // Slightly east of Khobar's longitude
      };
      const country = this.$store.state.auth.country_code;
      const center = this.getCenterCoordinates();
      this.map = new google.maps.Map(document.getElementById("mapDiv"), {
        center: center,
        zoom: 10,
      });

      const heatmapPoints = this.heatmapData.map((point) => {
        return new google.maps.LatLng(
          parseFloat(point.latitude),
          parseFloat(point.longitude)
        );
      });
      console.log(heatmapPoints);

      this.heatmap = new google.maps.visualization.HeatmapLayer({
        data: heatmapPoints,
        map: this.map,
        radius: 22,
      });
    },
  },

  data() {
    return {
      map: null,
      heatmap: null,
      mvcPoints: null,
      boundsFit: false,
      mapDiv: null,
      bounds: {},
    };
  },

  watch: {
    heatmapData(newPoints) {
      if (this.heatmap) {
        this.heatmap.setMap(null);
      }

      const heatmapPoints = newPoints.map((point) => {
        return new google.maps.LatLng(
          parseFloat(point.latitude),
          parseFloat(point.longitude)
        );
      });

      this.heatmap = new google.maps.visualization.HeatmapLayer({
        data: heatmapPoints,
        map: this.map,
        radius: 22,
      });
    },
  },
};
</script>

<style scoped></style>
